import { ArbetsorderHeaderPresentationRulesModel } from "../../arbetsorder-header-list-row/ArbetsorderHeaderPresentationRulesModel";
import { IArbetsorder } from "../../model/IArbetsorder";
import { SchemaPopupInfoDTO } from "../models/SchemaPopupInfoDTO";

export interface IArbetsorderStatusIcons {
    affarsform: string;
    viol3: boolean;
    maskinikon: boolean;
    produktsatt: boolean;
    koordinaterVerifierade: boolean;
    destinerad: boolean;
    detailsIconVisible: boolean;
    restriktionIconVisible: boolean;
    terminalVisible: boolean;
    importVisible: boolean;
    ckVisible: boolean;
    maskinIconVisible: boolean;
    produktsattIconVisible: boolean;
    destineradIconVisible: boolean;
    koordinaterVerifieradeIconVisible: boolean;
    valsStatusIconVisible: boolean;
    voStatusIconVisible: boolean;
    aktuellVirkesorderStatus: string;
    voContractDirty: boolean;
    skickadTillViol: boolean;
    skickadTillViol3: boolean;
    dirtyProduktionsdel: boolean;
    dirtyTransportdel: boolean;
    hasTransmissionErrorProduktionViol3: boolean;
    hasTransmissionErrorTransportViol3: boolean;
}

export class ArbetsorderStatusIcons implements IArbetsorderStatusIcons {

    affarsform: string;
    viol3: boolean;
    maskinikon: boolean;
    produktsatt: boolean;
    koordinaterVerifierade: boolean;
    destinerad: boolean;
    detailsIconVisible: boolean;
    restriktionIconVisible: boolean;

    terminalVisible: boolean;
    importVisible: boolean;
    ckVisible: boolean;
    maskinIconVisible: boolean;
    produktsattIconVisible: boolean;
    destineradIconVisible: boolean;
    koordinaterVerifieradeIconVisible: boolean;
    valsStatusIconVisible: boolean;
    voStatusIconVisible: boolean;
    aktuellVirkesorderStatus: string;
    voContractDirty: boolean;
    skickadTillViol: boolean;
    skickadTillViol3: boolean;
    dirtyProduktionsdel: boolean;
    dirtyTransportdel: boolean;
    hasTransmissionErrorProduktionViol3: boolean;
    hasTransmissionErrorTransportViol3: boolean;
    restriktionEjKlar: boolean;

    static fromArbetsorderFactory(arbetsorder: IArbetsorder, rulemodel: ArbetsorderHeaderPresentationRulesModel): IArbetsorderStatusIcons {
        const statusIcons = new ArbetsorderStatusIcons();
        statusIcons.affarsform = arbetsorder.affarsform;
        statusIcons.viol3 = arbetsorder.viol3;
        statusIcons.maskinikon = arbetsorder.maskinikon;
        statusIcons.produktsatt = arbetsorder.produktsatt;
        statusIcons.koordinaterVerifierade = arbetsorder.koordinaterVerifierade;
        statusIcons.destinerad = arbetsorder.destinerad;
        statusIcons.detailsIconVisible = rulemodel.detailsIconVisible;
        statusIcons.restriktionIconVisible = rulemodel.restriktionIconVisible;
        statusIcons.terminalVisible = rulemodel.terminalVisible;
        statusIcons.importVisible = rulemodel.importVisible;
        statusIcons.ckVisible = rulemodel.ckVisible;
        statusIcons.maskinIconVisible = rulemodel.maskinIconVisible;
        statusIcons.produktsattIconVisible = rulemodel.produktsattIconVisible;
        statusIcons.destineradIconVisible = rulemodel.destineradIconVisible;
        statusIcons.koordinaterVerifieradeIconVisible = rulemodel.koordinaterVerifieradeIconVisible;
        statusIcons.valsStatusIconVisible = rulemodel.valsStatusIconVisible;
        statusIcons.voStatusIconVisible = rulemodel.voStatusIconVisible;
        statusIcons.aktuellVirkesorderStatus = arbetsorder.aktuellVirkesorderStatus;
        statusIcons.voContractDirty = arbetsorder.voContractDirty;
        statusIcons.skickadTillViol = arbetsorder.skickadTillViol;
        statusIcons.skickadTillViol3 = arbetsorder.skickadTillViol3;
        statusIcons.dirtyProduktionsdel = arbetsorder.dirtyProduktionsdel;
        statusIcons.dirtyTransportdel = arbetsorder.dirtyTransportdel;
        statusIcons.hasTransmissionErrorProduktionViol3 = arbetsorder.hasTransmissionErrorProduktionViol3;
        statusIcons.hasTransmissionErrorTransportViol3 = arbetsorder.hasTransmissionErrorTransportViol3;
        statusIcons.restriktionEjKlar = arbetsorder.restriktionEjKlar;
        return statusIcons;
    }

    static fromPopupInfoFactory(popupInfo: SchemaPopupInfoDTO): IArbetsorderStatusIcons {
        const statusIcons = new ArbetsorderStatusIcons();
        statusIcons.affarsform = popupInfo.affarsform;
        statusIcons.viol3 = popupInfo.viol3;
        statusIcons.maskinikon = popupInfo.maskinikon;
        statusIcons.produktsatt = popupInfo.produktsatt;
        statusIcons.koordinaterVerifierade = popupInfo.koordinaterVerifierade;
        statusIcons.destinerad = popupInfo.destinerad;
        statusIcons.detailsIconVisible = popupInfo.detailsIconVisible;
        statusIcons.restriktionIconVisible = popupInfo.restriktionIconVisible;
        statusIcons.terminalVisible = popupInfo.terminalVisible;
        statusIcons.ckVisible = popupInfo.ckVisible;
        statusIcons.importVisible = popupInfo.importVisible;
        statusIcons.maskinIconVisible = popupInfo.maskinIconVisible;
        statusIcons.produktsattIconVisible = popupInfo.produktsattIconVisible;
        statusIcons.destineradIconVisible = popupInfo.destineradIconVisible;
        statusIcons.koordinaterVerifieradeIconVisible = popupInfo.koordinaterVerifieradeIconVisible;
        statusIcons.valsStatusIconVisible = popupInfo.valsStatusIconVisible;
        statusIcons.voStatusIconVisible = popupInfo.voStatusIconVisible;
        statusIcons.aktuellVirkesorderStatus = popupInfo.aktuellVirkesorderStatus;
        statusIcons.voContractDirty = popupInfo.voContractDirty;
        statusIcons.skickadTillViol = popupInfo.skickadTillViol;
        statusIcons.skickadTillViol3 = popupInfo.skickadTillViol3;
        statusIcons.dirtyProduktionsdel = popupInfo.dirtyProduktionsdel;
        statusIcons.dirtyTransportdel = popupInfo.dirtyTransportdel;
        statusIcons.hasTransmissionErrorProduktionViol3 = popupInfo.hasTransmissionErrorProduktionViol3;
        statusIcons.hasTransmissionErrorTransportViol3 = popupInfo.hasTransmissionErrorTransportViol3;
        statusIcons.restriktionEjKlar = popupInfo.restriktionEjKlar;
        return statusIcons;
    }
}
